import {AbstractModel} from "./abstract-model";

export class UploadFile extends AbstractModel {

  filename: string | null = null;
  data: string | null = null;

  isEmpty(): boolean {
    return !this.data || !this.filename;
  }

}
